/* Lavender Farm Simulator — Crew Break add-on v2 (for the farm's own crew; does nothing for anyone else).
   A crew member earns arcade minutes in Farm Scan and opens the game with a short-lived pass in the link:
     …/pages/lavender-farm-simulator#crewpass=<36 hex>&crewapi=<the Crew service address>
   With a valid pass this file: keeps time quietly (no clock on screen until the last minute, then a tiny one in the top corner so it never covers the menus), gives a one-time break bonus (+15 farm XP, +25 coins),
   and reports each finished arcade game back to Farm Scan's crew arcade board.
   It uses only the game's public hooks: #lfg-simulator-root, root._lfg (state/addXp/save/say) and the
   lfg:arcade-complete event. It changes no other file and no save format. Without a pass it exits at once. */
(function () {
  'use strict';
  if (window.GLLFCrewBreak) return;
  window.GLLFCrewBreak = { v: 2 };
  var KEY = 'gllf_crew_break_v1';
  var API_OK = /^https:\/\/gllf-crew-[a-z0-9-]+(\.[a-z0-9-]+)?\.run\.app$/;
  function ssGet() { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch (e) { return null; } }
  function ssSet(v) { try { v ? sessionStorage.setItem(KEY, JSON.stringify(v)) : sessionStorage.removeItem(KEY); } catch (e) {} }

  var m = /(?:^|[#&])crewpass=([a-f0-9]{36})(?:&crewapi=([^&]+))?/.exec(String(location.hash || ''));
  var saved = ssGet();
  if (m) {
    var api = ''; try { api = decodeURIComponent(m[2] || ''); } catch (e) {}
    api = api.replace(/\/$/, '');
    if (API_OK.test(api)) { saved = { pass: m[1], api: api }; ssSet(saved); }
    try { history.replaceState(null, '', location.pathname + location.search); } catch (e) {} /* the pass never stays in the address bar */
  }
  if (!saved || !saved.pass || !API_OK.test(saved.api || '')) return;

  var base = saved.api + '/api/crew/v1/arcade/pass/' + saved.pass;
  function call(path, body) {
    return fetch(base + path, body ? { method: 'POST', headers: { 'content-type': 'application/json' }, body: JSON.stringify(body) } : { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
  }
  function root() { return document.getElementById('lfg-simulator-root'); }
  function whenRoot(fn, tries) {
    var r = root();
    if (r && r._lfg && r._lfg.state) return fn(r);
    if ((tries || 0) > 120) return;
    setTimeout(function () { whenRoot(fn, (tries || 0) + 1); }, 500);
  }

  var bar, endsAt = 0, timer = 0, over = false;
  function css() {
    if (document.getElementById('gllf-crew-break-css')) return;
    var s = document.createElement('style'); s.id = 'gllf-crew-break-css';
    s.textContent = '.gcb-bar{position:fixed;left:50%;transform:translateX(-50%);bottom:calc(14px + env(safe-area-inset-bottom));z-index:2147483000;display:flex;align-items:center;gap:10px;padding:10px 16px;border-radius:999px;background:#3a2a66;color:#fff;font:700 16px/1.2 system-ui,sans-serif;box-shadow:0 6px 24px rgba(0,0,0,.35);border:2px solid #f3d98f}' +
      '.gcb-bar b{font-variant-numeric:tabular-nums;font-size:18px}.gcb-bar.low{background:#8a1c22}' +
      '.gcb-bar.tiny{left:auto;right:6px;transform:none;bottom:auto;top:calc(6px + env(safe-area-inset-top));gap:4px;padding:2px 7px;border-width:1px;font-size:11px;opacity:.88;pointer-events:none;box-shadow:none}.gcb-bar.tiny b{font-size:11px}' +
      '.gcb-over{position:fixed;inset:0;z-index:2147483001;display:grid;place-items:center;background:rgba(30,20,50,.82);padding:24px}' +
      '.gcb-card{max-width:420px;background:#fffaf0;color:#2c2337;border-radius:22px;padding:26px;text-align:center;font:400 18px/1.45 system-ui,sans-serif}' +
      '.gcb-card h2{margin:0 0 8px;font:800 26px/1.2 system-ui,sans-serif}.gcb-card button{margin-top:16px;min-height:52px;padding:0 22px;border-radius:14px;border:0;background:#e2b84a;color:#2c2337;font:800 18px system-ui,sans-serif;cursor:pointer}';
    document.head.appendChild(s);
  }
  function paint(name) {
    css();
    var leftNow = Math.max(0, Math.round((endsAt - Date.now()) / 1000));
    if (leftNow <= 0 && !over) return finish();
    /* v2: nothing on screen while there is more than a minute left */
    if (leftNow > 60) { if (bar) { bar.remove(); bar = null; } return; }
    if (!bar) { bar = document.createElement('div'); bar.className = 'gcb-bar'; bar.setAttribute('role', 'timer'); bar.setAttribute('aria-live', 'off'); document.body.appendChild(bar); }
    var left = Math.max(0, Math.round((endsAt - Date.now()) / 1000));
    bar.className = 'gcb-bar tiny low';
    bar.textContent = '';
    var label = document.createElement('span'); label.textContent = '🪻';
    var t = document.createElement('b'); t.textContent = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2);
    bar.appendChild(label); bar.appendChild(t);
    if (left <= 0 && !over) finish();
  }
  function finish() {
    over = true; clearInterval(timer); ssSet(null);
    if (bar) { bar.remove(); bar = null; }
    var wrap = document.createElement('div'); wrap.className = 'gcb-over'; wrap.setAttribute('role', 'dialog'); wrap.setAttribute('aria-modal', 'true');
    var card = document.createElement('div'); card.className = 'gcb-card';
    var h = document.createElement('h2'); h.textContent = "Break's over 🪻";
    var p = document.createElement('p'); p.textContent = 'Back to the lavender! Your scores are on the crew arcade board in Farm Scan.';
    var b = document.createElement('button'); b.type = 'button'; b.textContent = 'OK';
    b.addEventListener('click', function () { wrap.remove(); });
    card.appendChild(h); card.appendChild(p); card.appendChild(b); wrap.appendChild(card); document.body.appendChild(wrap);
    try { b.focus(); } catch (e) {}
  }

  var tries = 0;
  function start() { call('').then(function (p) {
    if (!p) { if (++tries < 4) setTimeout(start, 3000); return; } /* no signal: try again, keep the pass */
    if (!p.active) { ssSet(null); return; }
    endsAt = Date.now() + p.secondsLeft * 1000;
    paint(p.name); timer = setInterval(function () { paint(p.name); }, 1000);
    whenRoot(function (r) {
      if (!p.bonusUsed) call('/bonus', {}).then(function (b) {
        if (!b || !b.ok) return;
        try { var farm = r._lfg.state(); if (farm) farm.coins = (+farm.coins || 0) + (+b.coins || 0); } catch (e) {}
        try { r._lfg.addXp(+b.xp || 0); } catch (e) {}
        try { r._lfg.save(); } catch (e) {}
        try { r._lfg.say && r._lfg.say('Crew break bonus: +' + b.xp + ' XP and ' + b.coins + ' coins. Enjoy the arcade!'); } catch (e) {}
      });
      r.addEventListener('lfg:arcade-complete', function (e) {
        var d = (e && e.detail) || {};
        if (over || !d.game) return;
        call('/score', { game: String(d.game), score: +d.score || 0, raw: +d.raw || 0, stars: +d.stars || 0 });
      });
    });
  }); }
  start();
})();
